import React from 'react';
import PropTypes from 'prop-types';
import {PostRequest} from '../../common/service/PostRequest';
import LoginContainer from '../loginContainer';
import './forgotPassword.scss';
import {Button, InlineNotification} from '../../../../@elixir/components';
import InputField from '../../../../@elixir/components/widgets/inputs/InputField/InputField';
import FormTitle from '../common/formTitle/formTitle';


export default class ForgotPassword extends React.Component {

    constructor (props) {
        super(props);

        this.state = {
            username: '',
            email: '',
            didSendResetLink: false
        };
    }

    static contextTypes = {
        translator: PropTypes.func.isRequired
    };

    onUsernameChange (newValue) {
        this.setState({username: newValue});
    }

    onEmailChange (newValue) {
        this.setState({email: newValue});
    }

    onGoBackToLogin () {
        this.props.history.push('/login');
    }

    sendPasswordResetLink (isSubmitDisabled) {
        if (!isSubmitDisabled) {
            const {username, email} = this.state;
            const data = 'username=' + username + '&emailAddress=' + email;
            const forgotPasswordUrl = '/rest/User/forgotPassword';

            const isUrlFormEncoded = true;
            const request = new PostRequest(isUrlFormEncoded);
            request.post(forgotPasswordUrl, data).then(
                () => {
                    this.setState({
                        didSendResetLink: true
                    });
                }
            );
        }
    }

    render () {
        const sendLinkButtonLabel = this.context.translator('forgotPassword.sendLinkButtonLabel');

        const {
            username,
            email,
            didSendResetLink
        } = this.state;

        const hasUsernameFilled = username.length > 0;
        const hasEmailFilled = email.length > 0;
        const isSendLinkButtonDisabled = !(hasEmailFilled && hasUsernameFilled && !didSendResetLink);

        let formFeedback = '';

        if (didSendResetLink) {
            const successMessage = this.context.translator('forgotPassword.successMessage');
            formFeedback = (<InlineNotification className="submissionSuccess"
                                                type="success"
                                                isDismissable={true}
                                                message={successMessage}/>);
        }

        return (
            <LoginContainer
                className="forgotPassword"
                onEnterKeydown={this.sendPasswordResetLink.bind(this, isSendLinkButtonDisabled)}>

                <div className="errorContainer">
                    {formFeedback}
                </div>


                <div className="formHeader">
                    <Button className="backButton"
                            name="backButton"
                            type="tertiary"
                            icon="arrow-left"
                            onClick={this.onGoBackToLogin.bind(this)}>
                    </Button>

                    <FormTitle titleKey="forgotPassword.forgotPasswordTitle"/>
                </div>

                <div className="forgotPasswordComponent">

                    <InputField
                        className="username"
                        id="usernameInput"
                        controlClassName="usernameInput"
                        onValueChange={this.onUsernameChange.bind(this)}
                        value={username}
                        label="forgotPassword.usernameInputLabel"/>

                    <InputField
                        className="email"
                        id="emailInput"
                        inputType="email"
                        onValueChange={this.onEmailChange.bind(this)}
                        value={email}
                        label="forgotPassword.emailInputLabel"/>

                    <div className="actionButtonContainer">
                        <Button className="actionButton loginButton"
                                name="testButton"
                                type="primary"
                                disabled={isSendLinkButtonDisabled}
                                onClick={this.sendPasswordResetLink.bind(this, isSendLinkButtonDisabled)}>
                            <span>{sendLinkButtonLabel}</span>
                        </Button>
                    </div>
                </div>
            </LoginContainer>
        );
    }
}

